module.exports = __webpack_public_path__ + "static/media/use_esim_zhtw3.5cf47981.png";